import { Loader } from '@/shared/components/common/Loader';

import React from 'react';

export const PageLoader: React.FC = () => (
  <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '200px' }}>
    <Loader isLoading={true} />
  </div>
);
